<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="74" height="73" fill="none" viewBox="0 0 74 73"><circle cx="36" cy="36.861" r="36" fill="#FFEB37"/><path stroke="#000" stroke-width="2" d="m19.416 34.348 15.665 13.816L72.52 6.482"/></svg>
</template>

<script>
export default {
  name: "TheFastOrderSuccess"
}
</script>